module.exports = __webpack_public_path__ + "img/avatar-59.610288fd.png";